import apiSportsEvents from '@/api/sports-events'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  deleteSportsEventTrainersStart:
    '[delete sportsEvent Trainers] Delete sportsEvent Trainers start',
  deleteSportsEventTrainersSuccess:
    '[delete sportsEvent Trainers] Delete sportsEvent Trainers success',
  deleteSportsEventTrainersFailure:
    '[delete sportsEvent Trainers] Delete sportsEvent Trainers failure',
}

export const actionTypes = {
  deleteSportsEventTrainers:
    '[delete sportsEvent Trainers] Delete sportsEvent Trainers',
}

const mutations = {
  [mutationTypes.deleteSportsEventTrainersStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteSportsEventTrainersSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteSportsEventTrainersFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.deleteSportsEventTrainers](context, {id}) {
    context.commit(mutationTypes.deleteSportsEventTrainersStart)
    return new Promise((resolve) => {
      apiSportsEvents
        .deleteSportsEventsTrainers(id)
        .then((response) => {
          context.commit(mutationTypes.deleteSportsEventTrainersSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.deleteSportsEventTrainersFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
